module.exports = __webpack_public_path__ + "static/media/step8.f499f73a.png";